// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__MWjkk","tooltiptext":"Tooltip_tooltiptext__HYBsG"};